import type { InfiniteData } from '@tanstack/react-query'

import type { GroupDetail } from './schema'

function isGroupDetail(value: unknown): value is GroupDetail {
  return Boolean(value && typeof value === 'object' && 'orders' in value && 'group' in value)
}

function isInfiniteGroupDetail(value: unknown): value is InfiniteData<GroupDetail> {
  return Boolean(value && typeof value === 'object' && 'pages' in value)
}

/** Only remove IDs explicitly acknowledged as deleted, never failed orders. */
export function removeDeletedOrders(current: unknown, deletedIds: ReadonlySet<string>): unknown {
  if (isInfiniteGroupDetail(current)) {
    return { ...current, pages: current.pages.map((page) => removeFromPage(page, deletedIds)) }
  }
  return isGroupDetail(current) ? removeFromPage(current, deletedIds) : current
}

function removeFromPage(page: GroupDetail, deletedIds: ReadonlySet<string>): GroupDetail {
  return { ...page, orders: page.orders.filter((order) => !deletedIds.has(order.id)) }
}
